import React from 'react'
import Style from './Terms.module.css'

const Terms = () => {
  return (
    <>
      <div className="Navbar__Height"></div>
      <div className={Style.Terms__Page__Section}>
        <div className={Style.Header__Section}>
          <div className="container">
            <h1>Fyntiq Master Terms of Service</h1>
            <p>
              <strong>Effective Date:</strong> February 1, 2026 <br />
              <strong>Entity:</strong> Fyntiq Technologies, Inc. (“Fyntiq,” “we,”
              “us,” or “our”)
            </p>

            <p>
              These Terms of Service (“Terms”) govern access to and use of:
              <ul>
                <li>www.fyntiq.com</li>
                <li>pay.fyntiq.com</li>
                <li>All Fyntiq checkout interfaces</li>
                <li>APIs, dashboards, and software tools</li>
                <li>
                  All related financial technology services (collectively, the
                  “Services”).
                </li>
              </ul>
            </p>

            <p>
              By accessing or using the Services, you agree to be bound by these
              Terms.
            </p>

            <h4>1. Overview of Services</h4>
            <p>
              Fyntiq provides financial technology infrastructure that may
              include:
              <ul>
                <li>Merchant of Record services</li>
                <li>Checkout and billing solutions</li>
                <li>Software platform services</li>
                <li>Payment enablement integrations</li>
                <li>Settlement coordination</li>
                <li>Risk, fraud, and compliance monitoring</li>
              </ul>
            </p>
            <p>
              Fyntiq is not a bank; all payment processing occurs through
              regulated financial institutions and payment networks. Fyntiq may
              modify, suspend, restrict, or discontinue any Service at its sole
              discretion.
            </p>

            <h4>2. Transaction Models</h4>
            <p>
              Fyntiq may operate under the following models:
            </p>

            <h5>2.1 Merchant of Record Transactions (MoR Transactions)</h5>
            <p>
              <ul>
                <li>Fyntiq is the legal seller of record.</li>
                <li>Customers purchase directly from Fyntiq.</li>
                <li>Fyntiq appears on the Customer’s payment statement.</li>
                <li>Fyntiq manages billing, refunds, and chargebacks.</li>
              </ul>
            </p>
            <p>
              Suppliers may provide goods or services to Fyntiq for resale and
              may fulfill orders on Fyntiq’s behalf. Fyntiq retains discretion
              over order acceptance, pricing, refund determinations, and dispute
              handling.
            </p>

            <h5>2.2 Platform Transactions</h5>
            <p>
              <ul>
                <li>The Platform Merchant is the legal seller of record.</li>
                <li>Fyntiq provides software and transaction infrastructure.</li>
                <li>
                  Platform Merchants are fully responsible for product
                  compliance, customer service, and legal obligations.
                </li>
              </ul>
            </p>
            <p>
              Fyntiq does not assume product liability and may reclassify
              transactions to manage risk.
            </p>

            <h5>2.3 MoR Program Subscription Requirements</h5>
            <p>
              Participation in the MoR Program requires enrollment in an Eligible
              Plan:
              <ul>
                <li>Elite Plan</li>
                <li>Ambassador Plan</li>
                <li>Enterprise Plan</li>
              </ul>
            </p>
            <p>
              <strong>Minimum Commitment Term:</strong> 12 consecutive months from the
              date MoR processing begins. This term is not reduced by low
              volume, inactivity, or suspension.
            </p>
            <p>
              <strong>Early Termination:</strong> If a merchant cancels, downgrades,
              stops processing, migrates volume off-platform, or is terminated
              or suspended, an Early Termination Fee applies.
            </p>
            <p>
              <strong>Early Termination Fee:</strong> Monthly subscription rate ×
              remaining months in the 12 month commitment. Fyntiq may deduct
              fees from settlements, reserves, or invoice directly.
            </p>
            <p>
              Termination does not relieve merchants from the 12 month
              obligation.
            </p>

            <h4>3. Account Eligibility and Compliance</h4>
            <p>
              Users must:
              <ul>
                <li>Be legally authorized to conduct business</li>
                <li>Maintain required licenses and registrations</li>
                <li>Comply with applicable laws and regulations</li>
                <li>Follow payment network rules</li>
              </ul>
            </p>
            <p>
              Fyntiq may perform underwriting, identity verification, and
              ongoing monitoring. Approval does not equal regulatory approval.
            </p>

            <h4>4. AML, Sanctions, and Regulatory Cooperation</h4>
            <p>
              Users confirm they are not sanctioned, restricted, or located in
              sanctioned jurisdictions. Fyntiq may conduct screenings, freeze
              transactions, and share information with regulators or financial
              institutions.
            </p>

            <h4>5. Payment Network Compliance</h4>
            <p>
              Users agree to comply with Visa, Mastercard, American Express,
              Discover, and other network rules. Fines or assessments may be
              passed through to users.
            </p>

            <h4>6. Risk Monitoring and Transaction Controls</h4>
            <p>
              Fyntiq may decline transactions, suspend accounts, impose limits,
              adjust settlements, or hold reserves based on chargebacks, fraud,
              regulatory exposure, or partner requirements. Risk determinations
              are commercially reasonable and final.
            </p>

            <h4>7. Settlement and Reserves</h4>
            <p>
              <strong>7.1 Settlement Timing:</strong> Varies by transaction type, risk,
              and partner requirements.
            </p>
            <p>
              <strong>7.2 Reserves:</strong> Rolling, fixed, or dynamic reserves may
              be set and held to cover disputes or liabilities.
            </p>

            <h4>8. Financial Institution Supremacy</h4>
            <p>
              Fyntiq’s services depend on third-party institutions. Required
              suspensions, restrictions, or terminations by partners will be
              implemented immediately. Fyntiq is not liable for compliance
              actions required by partners.
            </p>

            <h4>9. User Representations and Warranties</h4>
            <p>
              Users warrant lawful offerings, accurate marketing, consumer
              protection compliance, and legitimate, bona fide commercial
              activity. Fyntiq may request documentation to verify compliance.
            </p>

            <h4>10. Data Usage, Monitoring, and Reporting</h4>
            <p>
              Fyntiq may monitor, analyze, and share transaction data with
              partners and regulators. Aggregated, anonymized data may be used
              to improve systems.
            </p>

            <h4>11. Intellectual Property</h4>
            <p>
              Users receive a limited, revocable license to use the Services.
              Reverse engineering, abuse, replication, or unauthorized branding
              use is prohibited. All IP remains with Fyntiq.
            </p>

            <h4>12. Suspension and Termination</h4>
            <p>
              Fyntiq may suspend or terminate services for risk, fraud, regulatory
              reasons, partner requirements, or Terms violations. Merchants in
              the MoR Program remain responsible for the 12 month commitment
              and any Early Termination Fee.
            </p>

            <h4>13. Indemnification</h4>
            <p>
              Users shall indemnify Fyntiq for losses related to product defects,
              regulatory violations, IP disputes, misrepresentations, and network
              fines.
            </p>

            <h4>14. Limitation of Liability</h4>
            <p>
              Fyntiq’s aggregate liability is capped at fees paid in the past 30 days
              or $1,000, whichever is greater. No liability for indirect or
              consequential damages applies.
            </p>

            <h4>15. No Fiduciary Relationship</h4>
            <p>
              Fyntiq is not a bank, fiduciary, escrow, trustee, or advisor. No
              partnership, joint venture, or agency is created.
            </p>

            <h4>16. Arbitration and Class Action Waiver</h4>
            <p>
              All disputes are resolved by binding AAA arbitration in Delaware.
              Users waive class actions, consolidated proceedings, and jury trials.
            </p>

            <h4>17. Export Controls</h4>
            <p>
              Users may not use Services in violation of U.S. export laws,
              sanctions, or trade restrictions.
            </p>

            <h4>18. Dormancy and Unclaimed Property</h4>
            <p>
              Dormant accounts may be closed and unclaimed funds handled per
              applicable law.
            </p>

            <h4>19. Force Majeure</h4>
            <p>
              Fyntiq is not liable for delays or failures caused by regulatory
              actions, partner disruptions, natural disasters, cyber events, or other
              factors beyond its control.
            </p>

            <h4>20. Assignment</h4>
            <p>
              Users may not assign these Terms without Fyntiq’s consent. Fyntiq
              may assign freely, including for mergers or acquisitions.
            </p>

            <h4>21. Severability and Entire Agreement</h4>
            <p>
              If any provision is invalid, the remainder remains in effect. These
              Terms constitute the full agreement between the parties.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Terms